module.exports = __webpack_public_path__ + "static/img/30004 (4).595a83a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30004 (4).webp
// module id = iLv1
// module chunks = 14